import axios from "axios";
import { ScenarioUsageResponse } from "../../types/models";
import { UserBillingResponse, UserTransaction } from "../../types/models/userTransaction";
const REACT_APP_API_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";

export const getScenarioUsage = async (): Promise<ScenarioUsageResponse[]> => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    throw new Error("Unauthorized: No token found.");
  }

  try {
    const response = await axios.get(`${REACT_APP_API_URL}/transactions/transactions/history`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching scenario usage:", error);
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data?.detail || "Failed to fetch scenario usage.");
    }
    throw new Error("An unexpected error occurred.");
  }
};



export const getAllUserTransactions = async (): Promise<UserBillingResponse[]> => {
  try {
    const token = localStorage.getItem("authToken");
    if (!token) throw new Error("Unauthorized: No token found.");

    const response = await axios.get(`${REACT_APP_API_URL}/transactions/client/all`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    return response.data;
  } catch (error) {
    console.error("Failed to fetch user transactions", error);
    throw new Error("Could not retrieve user transactions.");
  }
};

export const updateTransactionsStatus = async (transactionIds: number[]): Promise<void> => {
  try {
    const token = localStorage.getItem("authToken");
    if (!token) throw new Error("Unauthorized: No token found.");

    await axios.post(
      `${REACT_APP_API_URL}/transactions/update-status`,
      { transaction_ids: transactionIds },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  } catch (error) {
    console.error("Failed to update transaction statuses", error);
    throw new Error("Could not update transaction statuses.");
  }
};


export const payAllPendingTransactions = async (userId: number, transactionIds: number[]) => {
  const token = localStorage.getItem("authToken");
  if (!token) {
    throw new Error("Unauthorized: No token found.");
  }


  try {
    const response = await axios.post(
      `${REACT_APP_API_URL}/transactions/complete-all/${userId}`,
      { transaction_ids: transactionIds },  // ✅ send as object with correct key
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    
    return response.data;
  } catch {
    console.error("Failed to fetch transaction");
    return null;
  }
};



export async function getTransactionById(
  id: number
): Promise<UserTransaction | null> {
  try {
    const token = localStorage.getItem("authToken");
    const res = await axios.get<UserTransaction>(
      `${REACT_APP_API_URL}/transactions/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res.data;
  } catch {
    console.error("Failed to fetch transaction");
    return null;
  }
}

